<script setup>
import { Handle, Position, useNode } from '@vue-flow/core';
import { useI18n } from 'vue-i18n';
import { useNodeAudience } from '../../composables/useNodeAudience.js';

defineProps({
  data: { type: Object, default: () => ({}) },
  selected: { type: Boolean, default: false },
});

const { t } = useI18n();
const { id } = useNode();
const audienceCount = useNodeAudience(id);
</script>

<template>
  <div
    class="flow-node w-[180px] rounded-xl shadow-md border-2 transition-all"
    :class="selected ? 'border-orange-400' : 'border-transparent'"
  >
    <Handle type="target" :position="Position.Top" />

    <div class="flex items-center gap-2 px-3 py-2 bg-orange-500 text-white rounded-t-xl">
      <span class="i-lucide-code-2 size-4 shrink-0" />
      <span class="text-xs font-semibold truncate flex-1">{{ data.name || t('FLOW_BUILDER.NODES.CODE.TITLE') }}</span>
      <span
        v-if="audienceCount !== null"
        class="text-[9px] bg-white/20 rounded-full px-1.5 py-0.5 font-medium tabular-nums shrink-0"
      >
        {{ audienceCount }}
      </span>
    </div>

    <div class="px-3 py-2 bg-n-solid-1 text-n-slate-12 text-xs">
      <template v-if="data.code">
        <span class="font-mono text-[10px] text-n-slate-11 truncate block">{{ data.code.split('\n')[0] }}</span>
      </template>
      <span v-else class="text-n-slate-9">{{ t('FLOW_BUILDER.NODES.CODE.CONFIGURE') }}</span>
    </div>

    <div class="bg-n-solid-1 flex justify-between px-[18%] pt-1 pb-3 rounded-b-xl">
      <span class="text-[10px] text-n-slate-9">{{ t('FLOW_BUILDER.NODES.CODE.OUTPUT_OK') }}</span>
      <span class="text-[10px] text-n-slate-9">{{ t('FLOW_BUILDER.NODES.CODE.OUTPUT_ERROR') }}</span>
    </div>

    <Handle
      id="default"
      type="source"
      :position="Position.Bottom"
      class="!bg-n-teal-9 !border-n-teal-7"
      style="left: 25%"
    />
    <Handle
      id="error"
      type="source"
      :position="Position.Bottom"
      class="!bg-n-ruby-9 !border-n-ruby-7"
      style="left: 75%"
    />
  </div>
</template>
